import {createStore} from 'vuex'
import Common from './api/common'
import menuConfig from './js/config/menu-config';
import setting from "@/api/setting";
import {ArrToObj} from "@/js/common/utils";

const SubjectType = {
    ASSET: "资产",
    LIABILITY: "负债",
    RIGHTS: "权益",
    COST: "成本",
    INCOME: "损益",
    COMMON: "共同",
    NET_ASSETS: "净资产",
    REVENUE: "收入",
    EXPENSES: "支出"//10.10
};

export default createStore({
    state: {
        User: {
            name: '夏悸',
            desc: '执着于理想，纯粹于当下',
            email: 'HeyUI@some.com',
            org: '某某公司',
            dept: '某某部门',
            title: '前端开发工程师',
            location: '上海市',
            avatar: '/images/avatar.png',
            tags: ['善解人意', '耿直']
        },
        currentAccountSets: {},
        myAccountSets: [],
        tabs: [
            {
                title: "首页",
                key: "Home"
            },
            {
                title: "全部关闭",
                key: "CloseAllTab"
            }],
        subjectType: [],
        menus: [],
        currentTab: 'Home',
        currencyMap: {},
        sliderCollapsed: false
    },
    mutations: {
        newTab(state, tab) {
            let find = state.tabs.find(val => val.key === tab.key);
            if (!find) {
                state.tabs.push(tab);
            }
            state.currentTab = tab.key;
        },
        changeTab(state, tabKey) {
            state.currentTab = tabKey;
        },
        updateCurrency(state, currencyMap) {
            state.currencyMap = currencyMap;
        },
        refreshTab(state, tab) {
            let find = state.tabs.findIndex(val => val.key === tab.key);
            if (find !== -1) {
                state.tabs.splice(find, 1);
            }
            setTimeout(() => {
                state.tabs.push(tab);
            })
            state.currentTab = tab.key;
        },
        refreshHomeTab(state, tab) {
            state.tabs.push(tab)
            setTimeout(() => {
                state.tabs.splice(state.tabs.length - 1, 1)
            })
            state.currentTab = tab.key;
        },
        closeTab(state, tabKey) {
            let find = state.tabs.findIndex(val => val.key === tabKey);
            //jxd如过我直接调用 closeTab，this.$store.commit('closeTab', {key: "VoucherForm", title: "新增凭证"})
            //传进来的tabKey是个对象，造成找不到，所以如果找不到则再找一次
            if(find == -1){
                find = state.tabs.findIndex(val => val.key === tabKey.key);
            }
            if (find !== -1) {
                let next = Math.max(0, find - 1);
                state.currentTab = state.tabs[next].key;
                state.tabs.splice(find, 1);
            }
        },
        updateAccount(state, data) {
            state.User = data;
            state.currentAccountSets = data.accountSets;
            if (data.accountSets) {
                state.subjectType = data.accountSets.subjectCategory.map(val => SubjectType[val]);
            }
            state.myAccountSets = data.accountSetsList;
            const LOGINSTATUS = localStorage.getItem("LOGINSTATUS")
            if (LOGINSTATUS) {
                state.menus = menuConfig['EnterpriseWorkbench'];
            } else {
                state.menus = menuConfig[data.role];
            }
        },
        updateSliderCollapse(state, isShow) {
            setTimeout(() => {
                G.trigger('page_resize');
            }, 600);
            state.sliderCollapsed = isShow;
        }
    },
    actions: {
        init(context) {
            return new Promise((resolve, reject) => {
                Common.init().then(({data}) => {
                    context.commit('updateAccount', data.user);
                    context.commit('updateCurrency', data.currency);
                    resolve(data)
                }).catch(() => {
                    reject();
                })
            });
        },
        updateCurrency(context) {
            setting.currency.list().then(({data}) => {
                context.commit('updateCurrency', ArrToObj(data, val => val.id));
            })
        }
    },
    getters: {
        /**
         * 本位币
         * @param state
         * @returns {unknown}
         */
        localCurrency: state => {
            return Object.values(state.currencyMap).find(val => val.localCurrency)
        },
        tabMap: state => {
            const map = {};
            state.tabs.forEach(item => {
                map[item.key] = item;
            })
            return map;
        },
        account: state => {
            return state.User;
        },
        checkoutList: state => {
            return state.User.checkoutList;
        },
        firstCheckoutDate: state => {
            let reverse = state.User.checkoutList.filter(val => val.status !== 2).reverse();
            if (reverse.length) {
                // return reverse[0].checkDate;
                //强制改为月份的第一天
                return new Date(reverse[0].checkDate).setDate(1);
            }
            return null;
        },
        checkoutSelect: state => {
            return state.User.checkoutList.map(row => {
                return {
                    key: row.checkYear + '-' + row.checkMonth,
                    title: row.checkYear + '年' + row.checkMonth + "月",
                }
            });
        },
        sliderCollapsed: state => {
            return state.sliderCollapsed;
        }
    }
})
